import jQuery from 'jquery';

if (!window.jQuery) {
    window.jQuery = jQuery;
    window.$ = jQuery;
}
